class CustomMainviewSlideshow extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.custom-mainview__slide'));
    this.dots = Array.from(this.parentElement.querySelectorAll('.custom-mainview__dot'));
    this.currentIndex = Math.max(
      this.slides.findIndex((slide) => slide.classList.contains('is-active')),
      0
    );
    this.speed = (parseFloat(this.dataset.speed) || 5) * 1000;
    this.autoplayEnabled = this.dataset.autoplay === 'true' && this.slides.length > 1;

    if (this.autoplayEnabled) this.play();

    this.addEventListener('shopify:block:select', this.onBlockSelect.bind(this));
    this.addEventListener('shopify:block:deselect', this.onBlockDeselect.bind(this));
  }

  disconnectedCallback() {
    this.pause();
  }

  play() {
    this.pause();
    this.interval = setInterval(this.showNextSlide.bind(this), this.speed);
  }

  pause() {
    clearInterval(this.interval);
  }

  showSlide(index) {
    if (index === this.currentIndex) return;
    this.slides[this.currentIndex].classList.remove('is-active');
    this.slides[index].classList.add('is-active');
    if (this.dots.length) {
      this.dots[this.currentIndex].classList.remove('is-active');
      this.dots[index].classList.add('is-active');
    }
    this.currentIndex = index;
  }

  showNextSlide() {
    this.showSlide((this.currentIndex + 1) % this.slides.length);
  }

  onBlockSelect(event) {
    const index = this.slides.indexOf(event.target);
    if (index === -1) return;
    this.pause();
    this.showSlide(index);
  }

  onBlockDeselect() {
    if (this.autoplayEnabled) this.play();
  }
}

customElements.define('custom-mainview-slideshow', CustomMainviewSlideshow);
